var e={fullScreen:"ErrorViewer-module_fullScreen__DZlYT",container:"ErrorViewer-module_container__u-ToY",img:"ErrorViewer-module_img__u-ktV"};export{e as default};
//# sourceMappingURL=ErrorViewer.module.scss.js.map
